"use client";
import Table from "@/components/headToHead/Table";
import { TIME_IN_MS } from "@/constants/time";
import { GetGameLeadersQuery } from "@/graphql/gql/graphql";
import useGameLeaders from "@/utils/hooks/useGameLeaders";
import usePassingTable from "./usePassingTable";
import useReceivingTable from "./useReceivingTable";
import useRushingTable from "./useRushingTable";
import styles from "./gameLeaders.module.scss";

interface GameLeadersClientProps {
  gameId: number;
  initialData?: GetGameLeadersQuery;
  shouldRefetch?: boolean;
}

export default function GameLeadersClient({
  gameId,
  initialData,
  shouldRefetch = false,
}: GameLeadersClientProps) {
  const reactQueryOptions = {
    initialData,
    // Only perform refetching if in live state
    enabled: shouldRefetch,
    refetchInterval: shouldRefetch ? TIME_IN_MS.SEC_30 : undefined,
  };
  const { data } = useGameLeaders(gameId, reactQueryOptions);

  const eventData = data?.event;

  const passingTable = usePassingTable(eventData);
  const rushingTable = useRushingTable(eventData);
  const receivingTable = useReceivingTable(eventData);

  return (
    <div className={styles.tablesContainer}>
      <Table {...passingTable} />
      <Table {...rushingTable} />
      <Table {...receivingTable} />
    </div>
  );
}
